export const array=[
// const array = [
  {
      "name":"MAURITIUS",
      "wmsname":"MAURITIUS",
      "zoom":"10",
      "lat": -20.34 ,"lon": 57.55,
      "imageSuffix":"MAURITIUS",
   },
   // {
   //    "name": "MALDIVES",
   //    "wmsname":"MALDIVES",
   //    "zoom":"6",
   //    "lat": 4.04 ,"lon": 72.9,
   //    "imageSuffix":"MALDIVES",
   // },
   // {
   //    "name": "SRI LANKA",
   //    "wmsname":"SRI LANKA",
   //    "zoom":"6",
   //    "lat":7.87,"lon":80.77 ,
   //    "imageSuffix":"SRI LANKA",
   // },
   // {
   //    "name": "BHUTAN",
   //    "wmsname":"BHUTAN",
   //    "zoom":"6",
   //    "lat": 27.51,"lon":90.43 ,
   //    "imageSuffix":"BHUTAN",
   // },
   // {
   //    "name": "AFGHANISTAN",
   //    "wmsname":"AFGHANISTAN",
   //    "zoom":"6",
   //    "lat":33.93 ,"lon":67.71 ,
   //    "imageSuffix":"AFGHANISTAN",
   // },
   // {
   //    "name": "NEPAL",
   //    "wmsname":"NEPAL",
   //    "zoom":"6",
   //    "lat":28.39,"lon":84.12,
   //    "imageSuffix":"NEPAL",
   // },
   // {
   //    "name": "BANGLADESH",
   //    "wmsname":"BANGLADESH",
   //    "zoom":"6",
   //    "lat":23.68,"lon":90.35,
   //    "imageSuffix":"BANGLADESH",
   // },
  
]
export default array;
//Note: Name is compared for input value in URL (after UPPER CASE) and hence spaces are lethal in 'name'.